var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-menu"},[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"width":"300px","collapsed":_vm.collapsed},on:{"collapse":_vm.onCollapse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }